import { render, staticRenderFns } from "./addSetRecruitCost.vue?vue&type=template&id=94965254&"
import script from "./addSetRecruitCost.vue?vue&type=script&lang=js&"
export * from "./addSetRecruitCost.vue?vue&type=script&lang=js&"
import style0 from "./addSetRecruitCost.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports